import { Unicode } from '@shared/config/unicode';
export const showInSearchList = [
    'Риелторы из агентств недвижимости',
    'Самозанятные',
    'Индивидуальные предприниматели',
    `Частные риелторы с подтверждённым профилем, которые провели минимум 2 сделки за 12${Unicode.NoBreakSpace}месяцев и выбрали «Отображение в рейтинге» в разделе «Мой профиль»`,
    'Кредитные брокеры в поиске не видны'
];
